__turbopack_context__.v({
  "Viral": "dlist-module__Om1K6q__Viral",
  "cardImg": "dlist-module__Om1K6q__cardImg",
  "container": "dlist-module__Om1K6q__container",
  "dramaContent": "dlist-module__Om1K6q__dramaContent",
  "dramaName": "dlist-module__Om1K6q__dramaName",
  "dramaRelease": "dlist-module__Om1K6q__dramaRelease",
  "dramacard": "dlist-module__Om1K6q__dramacard",
  "dramacontentbody": "dlist-module__Om1K6q__dramacontentbody",
  "dramsHot": "dlist-module__Om1K6q__dramsHot",
  "episodeContinue": "dlist-module__Om1K6q__episodeContinue",
  "episodeContinueNum": "dlist-module__Om1K6q__episodeContinueNum",
  "hideSaveListIcon": "dlist-module__Om1K6q__hideSaveListIcon",
  "newdramaheading": "dlist-module__Om1K6q__newdramaheading",
  "playbtn": "dlist-module__Om1K6q__playbtn",
  "releaseBtns": "dlist-module__Om1K6q__releaseBtns",
  "shine3D": "dlist-module__Om1K6q__shine3D",
  "socialRelbtns": "dlist-module__Om1K6q__socialRelbtns",
  "socialRelbtnsSaveList": "dlist-module__Om1K6q__socialRelbtnsSaveList",
  "sway": "dlist-module__Om1K6q__sway",
});
